import React from "react";
import { Link } from "react-router-dom";

const colorMap = {
  green: {
    bg: "bg-green-100 dark:bg-green-500/20",
    icon: "text-green-600 dark:text-green-400",
    link: "text-green-500 hover:text-green-600",
  },
  blue: {
    bg: "bg-blue-100 dark:bg-blue-500/20",
    icon: "text-blue-600 dark:text-blue-400",
    link: "text-blue-500 hover:text-blue-600",
  },
  purple: {
    bg: "bg-purple-100 dark:bg-purple-500/20",
    icon: "text-purple-600 dark:text-purple-400",
    link: "text-purple-500 hover:text-purple-600",
  },
  orange: {
    bg: "bg-orange-100 dark:bg-orange-500/20",
    icon: "text-orange-600 dark:text-orange-400",
    link: "text-orange-500 hover:text-orange-600",
  },
};

const MiniStatisticCard = ({ title, value, icon, growth, color = "green", linkTo, loading }) => {
  const colors = colorMap[color] || colorMap.green;

  return (
    <div className="flex flex-col bg-white dark:bg-navy-800 px-4 py-3 rounded-[20px] shadow-xl shadow-shadow-500 dark:shadow-none">
      <div className="flex items-center justify-between">
        <div className={`flex h-12 w-12 items-center justify-center rounded-[12px] ${colors.bg}`}>
          <span className={`text-2xl ${colors.icon}`}>{icon}</span>
        </div>
        {growth !== undefined && growth !== null && (
          <div className="flex items-center text-sm font-bold text-green-500">
            <svg className="mr-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
            {growth}%
          </div>
        )}
      </div>

      <div className="mt-3">
        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
          {title}
        </p>
        {loading ? (
          <div className="mt-1 h-8 w-20 animate-pulse rounded bg-gray-200 dark:bg-navy-700" />
        ) : (
          <p className="mt-1 text-3xl font-bold text-navy-700 dark:text-white">
            {value ?? 0}
          </p>
        )}
      </div>

      {linkTo && (
        <Link
          to={linkTo}
          className={`mt-2 text-sm font-medium ${colors.link} transition-colors duration-150`}
        >
          Selengkapnya &rarr;
        </Link>
      )}
    </div>
  );
};

export default MiniStatisticCard;
